import $http from '$http';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';

export default {
    methods: {
        // 园所收货地址设置为默认
        getAgentAddressList(params) {
            this.loading = true;
            $http.get("api/Common/CRM_Agent_ConsigneeSetDefault", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: "设置默认地址成功",
                        type: 'success'
                    });
                });
            });
        },
        //新增收货地址
        addSchoolConsigneeList() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
            };
            this.loading = true;
            $http.post("api/Common/CRM_Agent_Consignee_Add", Object.assign({}, params, this.form)).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '添加成功',
                        type: 'success'
                    });
                    this.getAgentConsigneeList(this.AgentId)
                    this.form = this.initConsignee();
                    this.$refs.area.clearResultValue()

                });
            });
        },
        // 获取收货地址
        getAgentConsigneeList(id) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                AgentId: id,
                CustomerId: 0
            };
            this.loading = true;
            $http.get("api/Common/GetAgentConsigneeList", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.AddressList = Data;
                    for (let i = 0; i < this.AddressList.length; i++) {
                        //IsDefault==1为默认地址
                        if (this.AddressList[i].IsDefault == 1) {
                            this.$emit('address', this.AddressList[i])
                        }
                    }
                });
            });
        },
    }
}


// WEBPACK FOOTER //
// ./src/pages/Order/zqwOrder/components/AddressDialog/services.js